import IconComponent from '../components/icons';
import { PushGADataLayer, rectifyUndefinedState } from '../utils/helpers';

const shouldSendGAEvent = (title) => {
  // only send event when title is LOGIN 
  if(title === 'LOGIN'){
    PushGADataLayer('Navigations','Top Navigation',title)
  }
  /* do nothing */
}

const BaseButton = (props) => {

  const {title='', iconleft=false, size="large", type, className, btnType = '', disabled=false, btnClick = () => {shouldSendGAEvent(title)}} = props;
  let {classes, iconClassName, icon, href, target} = props;
  icon = rectifyUndefinedState(icon);
  href = rectifyUndefinedState(href);
  target = rectifyUndefinedState(target);
  iconClassName =(iconClassName!=='undefined' && iconClassName!==undefined) ? iconClassName : '';
  classes = (classes!=='undefined' && classes!==undefined) ? classes : '';

  let btnClasses = ' text-sm inline-flex items-center justify-center rounded-lg h-[42px] transition duration-300 tracking-widest';
  let iconClasses = ' flex-shrink-0 ' + iconClassName;

  switch (type){
    case 'primary' :   btnClasses += ' text-white bg-ek-red hover:bg-ek-red-200 active:bg-ek-red-300'; break;
    case 'secondary' :   btnClasses += ' bg-white text-ek-red hover:text-ek-red-200 active:text-ek-red-300 border border-ek-red hover:border-ek-red-200 active:border-ek-red-300'; break;
    case 'ghost' :   btnClasses += ' border border-white bg-ek-grey-700/40 text-white hover:text-ek-grey-300 active:text-ek-grey-400'; break;
    case 'tertiary' :   btnClasses += ' text-ek-red hover:text-ek-red-200 active:text-ek-red-300 font-bold lg:text-base h-auto'; break;
    default : break;
  }

  switch (size){
    case 'small' : btnClasses += ' px-[20px] py-[6px]'; break;
    case 'medium' : btnClasses += ' px-6 pb-2 pt-2.5 '; break;
    case 'large' : btnClasses += ' px-7 pb-2.5 pt-3 '; break;
    case 'none' : btnClasses += ' '; break;
    default : break;
  }

  const getButtonText = (icon, iconleft, title) => {
    if(icon){
      return (
      <>
        {iconleft?<IconComponent icon={icon} className={iconClasses}/>:null}
        <span className={`${(iconleft && !iconClassName)?'ml-[6px]':'mr-2'}`}>{title}</span>
        {!iconleft?<IconComponent icon={icon} className={iconClasses}/>:null}
      </>);
    }
    return (<span>{title}</span>)
  }

  const getButton = () => {
    return(
    <button className={btnClasses} type={btnType} onClick={(e)=>btnClick(e)} disabled={disabled}>
    {getButtonText(icon, iconleft, title)}
  </button>);
  }

  const getAnchorLink = () => {
    return(
    <a href={href} target={target} className={btnClasses} onClick={()=> btnClick()}>
    {getButtonText(icon, iconleft, title)}
  </a>);
  }

  btnClasses += ' '+ classes + `${className ? ' ' + className : ''}`;
    return (href ? getAnchorLink() : getButton())
}

export default BaseButton;